import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import React from 'react';

const EditorComponent = ({ onChange, value }) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      config={{
        toolbar: {
          removeItems: ['uploadImage'],
        },
      }}
      data={value}
      onChange={(event, editor) => {
        const data = editor.getData();
        onChange(data);
      }}
    />
  );
};
export default EditorComponent;
